import { render, staticRenderFns } from "./VanFieldSelectPicker.vue?vue&type=template&id=bd94aa5a&scoped=true&"
import script from "./VanFieldSelectPicker.vue?vue&type=script&lang=js&"
export * from "./VanFieldSelectPicker.vue?vue&type=script&lang=js&"
import style0 from "./VanFieldSelectPicker.vue?vue&type=style&index=0&id=bd94aa5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd94aa5a",
  null
  
)

export default component.exports